//dependencies
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
	browserLocalPersistence,
	getAuth,
	onAuthStateChanged,
} from "firebase/auth";
import type { User } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
	measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

// Set persistence and log any errors
auth
	.setPersistence(browserLocalPersistence)
	.then(() => {
		console.log("✅ Firebase persistence set to local");
	})
	.catch((error) => {
		console.error("❌ Error setting Firebase persistence:", error);
	});

// Add global auth error listener
auth.onAuthStateChanged(
	(user) => {
		console.log(
			"🔥 Global auth state changed:",
			user ? `User: ${user.email}` : "No user",
		);
	},
	(error) => {
		console.error("❌ Global auth state error:", error);
	},
);

const messaging = getMessaging(app);
const analytics = getAnalytics(app);

const getCurrentUser = (): Promise<User | null> => {
	return new Promise((resolve, reject) => {
		const unsubscribe = onAuthStateChanged(
			auth,
			(user) => {
				console.log(
					"🔐 Auth state changed:",
					user
						? {
								uid: user.uid,
								email: user.email,
								displayName: user.displayName,
							}
						: null,
				);
				unsubscribe();
				resolve(user);
			},
			(err) => {
				console.error("❌ Auth state error:", err);
				unsubscribe();
				reject(err);
			},
		);
	});
};

export { auth, getCurrentUser, app, messaging, analytics };
